module.exports = __webpack_public_path__ + "static/img/pokdenggame_en.fb2c463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/pokdenggame_en.png
// module id = Gnn6
// module chunks = 1